import React, { useState } from "react";
import "../../css/entry.css";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import TokenService from "../../service/TokenService";
import dayjs from "dayjs";

import EncryptService from "../../service/EncryptionService";

import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";

import {  Button } from "@mui/material";

function EditBill() {
  const navigate = useNavigate();
  const [poNumber, setpoNumber] = useState("");
  const [poValue, setpoValue] = useState(0);
  const [poQuantity, setpoQuantity] = useState(0);
  const [poDate, setpoDate] = useState(null);
 const [gemchecked, setgemChecked] = useState(false); // Default is false
 const [gemDate, setGemDate] = useState(null);
  const [billDate, setBillDate] = useState(null);
  const [billQuantity, setbillQuantity] = useState(0);
  const [billValue, setbillValue] = useState(0);
  const [reason, setReason] = useState("");
  const [BillReceiptDate, setBillReceiptDate] = useState(null);
  const [NodalBillReceiptDate, setNodalBillReceiptDate] = useState(null);
  const today = dayjs();

  const handleChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    setpoNumber(alphanumericValue);
  };




  const [billNumber, setbillNumber] = useState();
  const [oldbillNumber, setoldbillNumber] = useState();


  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [showRemark, setShowRemark] = useState(true);

   
  const handleQuantityChange = (value) => {
    setbillQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setbillValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };








 const resetData = async () => {
  setgemChecked(null);
  setGemDate(null);
   setpoDate(null);
   setpoNumber("");
   setBillDate(null);
   setBillReceiptDate(null);
   setbillValue(0);
   setbillNumber("");
   setbillQuantity(0);
   setSelectedOption(0);
   setReason(null);
  setpoQuantity(0);
  setpoValue(0);
setoldbillNumber("");





  };






  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);

    // alert(selvalue);
    if (selvalue === "0") {
      setShowRemark(true);
      setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  //console.log(indentId);

  const UpdateBillData = async (e) => {

    e.preventDefault();
    let formErrors = {};
   
    if (!billDate) {formErrors.errBillDate = "Invalid Bill Date";}
    if (!BillReceiptDate) {formErrors.errreceiptDate = "Invalid Bill Receipt Date";}
   // if (!NodalBillReceiptDate) {formErrors.errnodalDate = "Invalid Nodal Push date Date";}

    if (!billNumber || billNumber.length === 0)
      formErrors.errBill = "Invalid Bill Number";

    if (parseFloat(billQuantity) > parseFloat(poQuantity))
      formErrors.qty = "Qty should be less or equel then PO Qty";

    if (parseFloat(billValue) > parseFloat(poValue))
      formErrors.val = "Value should be less or equel then PO Qty";

    if (!billQuantity || parseFloat(billQuantity) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (!billValue || parseFloat(billValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (selectedOption === "1") {
      if (reason.length === 0)
        formErrors.reasonerr = "Remark Should not be Blank";
    }

    if (selectedOption === "0") {
      setReason(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Bill Receipt Type Not Selected";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const BillRecdt = new Date(BillReceiptDate);
      const BillReceiptDate1 =
        BillRecdt.getFullYear() +
        "/" +
        parseInt(BillRecdt.getMonth() + 1) +
        "/" +
        BillRecdt.getDate();

      const billdt = new Date(billDate);
      const billDate1 =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

        const nodaldt = new Date(NodalBillReceiptDate);
        const nodaldt1 =
        nodaldt.getFullYear() +
          "/" +
          parseInt(nodaldt.getMonth() + 1) +
          "/" +
          nodaldt.getDate();
  

       

      apiClient.post("/billdataupdate", {

        newbillnumber:billNumber,	
        billdate:billDate1,	
        billitemQty:billQuantity,	
        billitemValue:billValue,	
        paymenttype:selectedOption,	
        remark:reason,	
        billreceiptdate:BillReceiptDate1,	
        ponumber:poNumber,		
        oldbillnumber:oldbillNumber,
        uname,
        ip,	


        
        })
        .then(function (response) {
          console.log(response.data);
          resetData();
        
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate Bill Number for this PO Not Allowed");
       }
     });
    }
  };

  

 
    const getdata = async (e) => {
    apiClient.post("/partPaymentList_by_PONumber_Billnumber", {
      ponumber: poNumber,
      oldbillnumber:oldbillNumber,
      })
      .then(function (response) {
       
        setgemChecked(response.data[0].gemtype);
        setGemDate(response.data[0].gemdate);
         setpoDate(response.data[0].PODate);
         setBillDate(dayjs(response.data[0].billdate));
         setBillReceiptDate(dayjs(response.data[0].billreceiptdate));
         setbillValue(response.data[0].billitemValue);
         setbillNumber(response.data[0].billnumber);
         setbillQuantity(response.data[0].billitemquantity);
         setSelectedOption(response.data[0].paymenttype);
         setReason(response.data[0].remark);
        setpoQuantity(response.data[0].POQty);
        setpoValue(response.data[0].POValue);

      })
      .catch(function (error) {
  console.error("API Error:", error); // log full error for debugging
  const errorMsg = error?.response?.data?.message || error.message || "Unknown error occurred";
  //setError(errorMsg);
  alert("Error fetching data: " + errorMsg);
  resetData(); // Reset form fields on error
});
  };


  const menuoptions = [
    { value: "0", label: "Full Payment" },
    { value: "1", label: "Partial Payment" },
    { value: "2", label: "Final Payment of Partial Paid" },
  ];



  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
    <div>
     

          <div className="row p-2" >


          <div className="container">
            <div className="input-group">
              <CustomTextField
                label="PO Number (Max 20 Character)*"
                value={poNumber || ""}
                onChange={handleChange}
                placeholder="PO Number (Max 20 Character)*"
                maxLength={20} // Set the maximum length
                
              />
            </div>
            <div className="input-group">
            <CustomTextField
                  label="Old Bill/Invoice Number"
                  value={oldbillNumber}
                  onChange={(e) => {
                    setoldbillNumber(e.target.value);
                  }}
                  placeholder="Old Bill/Invoice Number"
                  maxLength={50} // Set the maximum length
                 
                />
            </div>
            <div className="input-group">
            <Button
  variant="contained"
  color="primary"
  startIcon={<SearchIcon />}
 onClick={getdata}
  disabled={!(oldbillNumber && poNumber)} // Button is disabled until both values are present
>
  Search
</Button>
            </div>
          </div>

          <div className="container">
              <div className="input-group mt-2">
              <CustomTextField
                  label="PO Date"
                  value={poDate?dayjs(poDate).format("DD-MMM-YYYY"):""}
                  disabled={true}
              />
              </div>

              <div className="input-group mt-2">
              <CustomTextField
                  label="GeM Date"
                  value={gemDate?dayjs(gemDate).format("DD-MMM-YYYY"):""}
                  disabled={true}
              />
              </div>
            </div>



            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="Bill/Invoice Date"
                  id="billdate"
                  value={billDate}
                 
                 //onChange={setBillDate}
                 
                  onChange={(newDate) =>
                    handleDateChange(newDate, setBillDate)
                  } 
                 
                  error={errors.errBillDate}
                 
                  maxDate={today}

                  


                 //minDate={poDate?dayjs(poDate):dayjs()}
                minDate={gemchecked ? dayjs(gemDate) : dayjs(poDate)}
                 // minDate={minCalDate}
                />
              </div>

              <div className="input-group mt-2">
                <CustomTextField
                  label="New Bill/Invoice Number"
                  value={billNumber}
                  onChange={(e) => {
                    setbillNumber(e.target.value);
                  }}
                  placeholder="New Bill/Invoice Number"
                  maxLength={50} // Set the maximum length
                  error={!!errors.errBill}
                  helperText={errors.errBill}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <NumericTextField
                  id="ItemQuantity"
                  label="Quantity"
                  title="Quantity"
                  error={errors.qty}
                  value={billQuantity}
                  onChange={handleQuantityChange}
                />
              </div>

              <div className="input-group">
                <NumericTextField
                  id="ItemValue"
                  label="Item Value"
                  title="Item Value"
                  error={errors.val}
                  value={billValue}
                  onChange={handleValueChange}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="Bill/Invoice Receiving  Date"
                  id="BillReceiptDate"
                  value={BillReceiptDate}
                                 
                    onChange={(newDate) =>
                    handleDateChange(newDate, setBillReceiptDate)
                  } 
                  error={errors.errreceiptDate}
                  maxDate={today}
                 // minDate={billDate?dayjs(billDate):dayjs()}
                  //minDate={minCalDate}
                />
              </div>

              <div className="input-group mt-2">
                <CustomDropdownMenu
                  options={menuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={error}
                  menulabel="Select Payment Option"
                />
              </div>



              {/* <div className="input-group">
                <DatePickerComponent
                  label="Bill Submited to Nodal Section Date"
                  id="NodalSubmitBillDate"
                  value={NodalBillReceiptDate}
                    onChange={(newDate) =>
                    handleDateChange(newDate, setNodalBillReceiptDate)
                  } 
                error={errors.errnodalDate}
                  
                  maxDate={today}
                 // minDate={billDate?dayjs(billDate):dayjs()}
                  //minDate={minCalDate}
                />
              </div> */}


            </div>

            {/* here */}

            {!showRemark && (
              <div className="input-group">
                <CustomTextField
                  label="Reason Why ---> Partial Payment done "
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                  placeholder="Reason"
                  maxLength={100} // Set the maximum length
                  error={!!errors.reasonerr}
                  helperText={errors.reasonerr}
                />
              </div>
            )}
          </div>

         
          <>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
               onClick={UpdateBillData}
               disabled={!billNumber}
                title="Click for Data Update"
              >
                Update Data
              </button>


            </div>
          </>
       
    </div>
  );
}


export default EditBill